import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=2547a3fb&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"
import style0 from "./Category.vue?vue&type=style&index=0&id=2547a3fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547a3fb",
  null
  
)

export default component.exports